import EventActionProto from '../event-action-proto'

const debug = false
// const debug = "SessionMyTasksNew"

export default class SessionMyTasksNew extends EventActionProto {

    constructor(sessionEvent) {
        super(sessionEvent.uid, sessionEvent.data, sessionEvent.companyId)
        this.method     = sessionEvent.method
        this.fromSID    = sessionEvent.fromSID
    }

    process() {
        if (this.isDifferentCompany()) return false

        debug && console.log(debug, "process", this)

        if (!!gd.session.assignedTasks && !gd.session.assignedTasks.getTask(this.data.id)) {
            gd.session.assignedTasks.add(this.data)
            debug && console.log(debug, "process", this, gd.session.assignedTasks.get(this.data.id))

            // bus event should be 'my-task' because it is synthetic event
            // but not actual 'task new' session event
            gd.modelBus.newUpdate('my-task', 'new', this.data.id, this.data, {
                task        : this.data,
                isBulkUpdate: true,
            })
        }
    }
};
